/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { Navigate } from 'react-router-dom'

import PasswordWidget from '../widgets/PasswordWidget.js'

import { AppContext } from '../AppContext'

class ConfirmSignup extends React.Component
{

  // Note: If this is a page external to the app, you need to change the redirect code as well (see below)
  // redirectURI = "https://asteriondb.com";

  
  redirectTimer = null;

  async componentDidMount()
  {
    // because we only expect a single argument,
    // instead of parsing multiple query arguments, 
    // we can actually treat this as a security
    // enhancement and ignore requests that aren't
    // what we expect
    if (window.location.search.substring(0, 1) !== '?'
     || /[^0-9a-zA-Z]/.test(window.location.search.substring(1)))
    {
      // redirect back to login page
      // to external URI:
      // window.location.href = this.redirectURI;
      // can use history.push() if you want the current page to stay in the browser history
      this.setState({confirmationTokenValid: false});
      return;
    }

    // by taking the entire query string without checking, if the user
    // adds anything funny, they will just invalidate their request
    // (as long as the DB passes this entire string to its decrypt function)
    let bodyData = {confirmationToken: window.location.search.substring(1)};
    
    // check if what appears to be a valid token *really* is valid
    let result = await this.context.dbTwig.callRestAPI('icam', 'checkConfirmationToken', bodyData);
    if ('apiError' === result.status && this.context.dbTwig.InvalidConfirmationData === result.errorCode) 
    {
      this.setState({confirmationTokenValid: false});
      return;
    }
    if ('success' !== result.status)
    {
      this.context.dbTwig.apiErrorHandler(result, 'Unable to confirm validation data');
      this.setState({confirmationTokenValid: false});
      return;
    }

    this.setState({confirmationTokenValid: true});
  }
  
  constructor(props)
  {
    super();

    this.state =
    {
      username: '',
      usernameValid: undefined,
      password: '',
      passwordValid: undefined,
      passwordDisabled: true,
      buttonDisabled: true,
      confirmationTokenValid: null
    };

    this.setUsername = this.setUsername.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.login = this.login.bind(this);
  }

  async login(event)
  {
    event.preventDefault();
    this.setState({buttonDisabled: true});

    var confirmationToken = window.location.search.substring(1);

    let bodyData = 
    {
      identification: this.state.username,
      password: this.state.password,
      confirmationToken: confirmationToken
    }

    let result = await this.context.dbTwig.callRestAPI('icam', 'confirmUserRegistration', bodyData);
    if ('success' !== result.status)
    {
      this.setState({buttonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Login failed');
    } 

    if (result.jsonData.accountStatus !== 'active')
    {
      this.context.postNotification('info', 'You are logged in but your account is locked.');
    }
    else
    {
      this.context.postNotification('success', 'Login successful, account confirmed.');
      this.context.authorize(result.jsonData);
    }
  }

  render()
  {
    if (null === this.state.confirmationTokenValid) return null;
    if (!this.state.confirmationTokenValid) console.log(this.state.confirmationTokenValid);
    if (!this.state.confirmationTokenValid) return (<Navigate to={{pathname: '/login', replace: true}} />);

    return(  
      <div>
        <br></br>
        <Row>
          <Col >
            <h3>Please log in to confirm access to your new account.</h3>
          </Col>
        </Row>
        <br></br>
        <Form onSubmit={(e) => this.login(e)}>
          <FormGroup row>
            <Label for="username" sm="1">Username</Label>
            <Col sm="3">
              <Input type="text" id="username" placeholder="Enter your username" value={this.state.username}
                invalid={(undefined === this.state.usernameValid ? undefined : !this.state.usernameValid)} 
                valid={(undefined === this.state.usernameValid ? undefined : this.state.usernameValid)} 
                onChange={this.setUsername} autoFocus 
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="password" sm="1">Password</Label>
            <Col sm="3" >
              <PasswordWidget disabled={this.state.passwordDisabled} onChange={this.setPassword} buttonDisabled={this.state.buttonDisabled}
                login={this.login} placeholder='Enter your password' value={this.state.password} id="password"/>
            </Col>
          </FormGroup>
          <Row>
            <Col sm={{ size: 2, offset: 1 }}>
              <Button disabled={this.state.buttonDisabled} type="submit" color="primary" >Login</Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  setPassword(password)
  {
    let disabled = ('' === password ? true : false);
    this.setState({password: password, buttonDisabled: disabled});
  }

  setUsername(event)
  {
    if ('' !== event.target.value && !window.usernameIsValid(event.target.value)) return;
    
    let passwordDisabled = ('' === event.target.value ? true : false);
    let buttonDisabled = true;
    if ('' !== event.target.value && '' !== this.state.password) buttonDisabled = false;
    let password = ('' === event.target.value ? '' : this.state.password);
    this.setState(
    {
      username: event.target.value,
      passwordDisabled: passwordDisabled,
      buttonDisabled: buttonDisabled,
      password: password
    });
  }

  togglePasswordReveal(event)
  {
    this.passwordRevealed = !this.passwordRevealed; 
    if (this.passwordRevealed) 
    { 
      this.setState({passwordType: 'text'});
      this.passwordTimer = setTimeout(this.hidePassword, window.passwordRevealTimeout); 
    } 
    else 
      this.setState({passwordType: 'password'}); 
      
    event.preventDefault();
  }     
}

ConfirmSignup.contextType = AppContext;

export default ConfirmSignup;
